import React, { useState, useEffect, useRef } from "react";
import { compose } from "redux";

import connectProps from "fantastic/lib/connectProps";
import styles from "fantastic/components/hoc/styles";

const Edited = ({
  id,
  style,
  app: { html: { value } }
}) => {

  const handleOpen = () => {
    if (preview)
      return;
    editId(id);
  }

  const handleClick = (e) => {
    e.preventDefault();
    return false;
  }

  return (
    <div style={style}>
      <div
        className="ftc-html-block"
        onClick={handleClick}
        dangerouslySetInnerHTML={{ __html: value }}
      />
    </div>
  );
};

export default compose(
  connectProps("app"),
  styles("background", "padding", "visibility")
)(Edited);
